module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/plugin.worker.shim-06dd57c74a5113af2496.js");
};